import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '@bb/session-manager';

import {
  CONTRACT_DELETE_ENDPOINT,
  CLAUSES_DELETE_ENDPOINT,
} from '../../endpoints.config';
import { useAGTableContext } from '../../contexts/AGTableProvider';
import { BBConfirmationDialog } from '../../components';

export const DeleteContractClauseDialog = ({ page, onSuccess }) => {
  const { bbAxios } = useAuth();
  const { tableApi, activeRow, openDelete, setOpenDelete, update, setUpdate } =
    useAGTableContext();

  const [isLoading, setIsLoading] = useState(false);
  const [targetRows, setTargetRows] = useState(null);
  const [targetName, setTargetName] = useState('');

  const handleClose = () => {
    setOpenDelete(false);
  };

  const deleteFiles = (deleteList) => {
    const promiseList = deleteList.reduce((result, { _id: id }) => {
      const endpoint =
        page === 'contract' ? CONTRACT_DELETE_ENDPOINT : CLAUSES_DELETE_ENDPOINT;
      const promise = bbAxios.delete(`${endpoint}${id}`).catch((error) => {
        console.error(error);
      });
      return [promise, ...result];
    }, []);

    Promise.all(promiseList)
      .then(() => {
        setOpenDelete(false);
        setUpdate(update + 1);
        onSuccess?.();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setIsLoading(false));
  };

  const handleDelete = () => {
    setIsLoading(true);

    if (page === 'contract') {
      deleteFiles([targetRows]);
    } else {
      deleteFiles(Object.values(targetRows));
    }
  };

  useEffect(() => {
    if (tableApi) {
      const toDelete = tableApi.getDisplayedRowAtIndex(activeRow)?.data;

      if (page === 'contract') {
        const { name } = toDelete || {};
        setTargetName(name);
      } else {
        const {
          as_receiving_party: asReceivingParty,
          as_receiving_party_you: asReceivingPartyYou,
        } = toDelete;
        // Check if clause exists because some databases have partial data
        if (asReceivingParty) {
          const { title } = asReceivingParty;
          setTargetName(title);
        } else if (asReceivingPartyYou) {
          const { title } = asReceivingPartyYou;
          setTargetName(title);
        }
      }

      setTargetRows(toDelete);
    }
  }, [openDelete]);

  return (
    <BBConfirmationDialog
      isDangerous
      isOpen={openDelete}
      isLoading={isLoading}
      title={`Delete ${page === 'contract' ? 'Contract' : 'Clause'}`}
      subtitle={
        <>
          {`Are you sure you wish to delete the ${page === 'contract' ? 'contract' : 'clause'}: `}
          <strong>{targetName}</strong>?
        </>
      }
      confirmText="Delete"
      onClose={handleClose}
      onConfirm={handleDelete}
    />
  );
};

DeleteContractClauseDialog.propTypes = {
  page: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
};
